import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export type DateComparison = '<' | '>' | '=';

@Component({
  selector: 'app-date-comparison-filter',
  templateUrl: './date-comparison-filter.component.html',
  styleUrl: './date-comparison-filter.component.scss'
})
export class DateComparisonFilterComponent {
  @Input() filterId = '';
  @Input() label = '';
  @Input() comparison: DateComparison = '=';
  @Output() comparisonChange = new EventEmitter<DateComparison>();
  @Input() date: NgbDateStruct | null = null;
  @Output() dateChange = new EventEmitter<NgbDateStruct | null>();
  constructor(public formatter: NgbDateParserFormatter) {}

  selectComparison(comparison: DateComparison): void {
    this.comparison = comparison;
    this.comparisonChange.emit(comparison);
  }

  selectDate(date: NgbDateStruct | null): void {
    this.date = date;
    this.dateChange.emit(date);
  }

}
